import React from 'react';
import {Chip} from '@mui/material';
import {FileTag} from '@pages/FilesPage';

type Props = {
    tag: FileTag;
    onDelete?: () => void;
};

export function FileTagChip({tag, onDelete}: Props) {
    return (
        <Chip
            size='small'
            label={tag.title}
            onDelete={onDelete}
            sx={{
                border: 'none',
                borderRadius: '100px',
                fontSize: '12px',
                color: 'primary.main',
                backgroundColor: 'rgba(3, 155, 229, 0.1)',
                '& .MuiChip-deleteIcon': {
                    color: 'primary.main',
                    opacity: 0.26,
                },
            }}
        />
    );
}
